import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "kyocera",
  "use": "kyocera-usage",
  "viewBox": "0 0 142.469 151.25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 142.469 151.25\" id=\"kyocera\"><path fill=\"#e31a2f\" d=\"M95.875 0 66.594 29.188h46.594v46.437l29.28-29.188V0zm17.312 75.625v46.438H66.594l29.281 29.187h46.594v-46.437zm0 0L66.594 29.187v92.876zm-46.593 46.438L20 75.625v46.438zM20 75.625l46.594-46.438H20z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol